// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"N7-z","displaySixCardTiles":"O7-z"};